import React from "react";
import { useDispatch, useSelector } from "react-redux";
import SearchBar from "components/SearchBar/searchBar";
import InfoCard from "components/InfoCard";
import { setSearchTerm } from "slices/userAdmin/userAdminSlice";

const UsersHeader = () => {
  const dispatch = useDispatch();

  const workspaceInfo = useSelector((state) => state.userAdmin?.workspaceInfo);
  const searchTerm = useSelector((state) => state.userAdmin?.searchTerm);

  const licensedUsers = workspaceInfo?.workspaces[0].users.filter(
    (u) => u.licensed
  ).length;

  return (
    <div className="user_admin__header" data-testid="user_admin-header">
      <div className="user_admin__header__searchbar__container">
        <SearchBar
          searchMode={searchTerm !== ""}
          textFromProps={searchTerm}
          onSubmit={(term) => {
            dispatch(setSearchTerm(term));
          }}
          onClear={() => {
            dispatch(setSearchTerm(""));
          }}
        />
      </div>
      <div className="user_admin__header__button_holder">
        <div
          className="user_admin__header__button_holder__info"
          data-testid="user_admin-button_holder"
        >
          <InfoCard
            right={
              <span className="user_admin__header__button_holder__info__text">
                Total License <br /> Count
              </span>
            }
            left={
              <span className="user_admin__header__button_holder__info__number">
                {workspaceInfo?.licenseCount}
              </span>
            }
          />
          <InfoCard
            right={
              <span className="user_admin__header__button_holder__info__text">
                Licensed Users
              </span>
            }
            left={
              <span className="user_admin__header__button_holder__info__number">
                {licensedUsers}
              </span>
            }
          />
        </div>
      </div>
    </div>
  );
};

export default UsersHeader;
